/**
 * Factory to return ITelemetryLogger objects
 */
import AriaTelemetryLogger from "./AriaTelemetryLogger";
export default class TelemetryLoggerFactory {
  static create(tenantToken, namespace, app, session, host, release, browser, device, user) {
    return new AriaTelemetryLogger(tenantToken, namespace, app, session, host, release, browser, device, user);
  }
}